import { useEffect, useRef } from 'react';

/**
 * Fires `callback` once after `delay` ms. Pass `null` as the delay to disable
 * (or cancel a pending timeout). The latest `callback` is always invoked, so
 * the caller does not need to memoise it.
 */
export function useTimeout(callback: () => void, delay: number | null): void {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay === null) return;

    const id = setTimeout(() => callbackRef.current(), delay);
    return () => clearTimeout(id);
  }, [delay]);
}
